
import React, { useCallback, useEffect, useRef, useState } from 'react'
import Blockquote from '@tiptap/extension-blockquote'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import { Color } from '@tiptap/extension-color'
import TextStyle from '@tiptap/extension-text-style'
import { FontFamily } from '@tiptap/extension-font-family'
import Underline from '@tiptap/extension-underline'
import AttachmentIcon from "../../images/attachmentIcon.svg"
import BulletList from '@tiptap/extension-bullet-list'
import ListItem from '@tiptap/extension-list-item'
import OrderedList from '@tiptap/extension-ordered-list'
import Heading from '@tiptap/extension-heading'
import HardBreak from '@tiptap/extension-hard-break'
import WidgetsIcon from '@mui/icons-material/Widgets';
import Mention from '@tiptap/extension-mention'
import suggestion from './suggestion.js'

import Subscript from '@tiptap/extension-subscript'
import Superscript from '@tiptap/extension-superscript'

import HorizontalRule from '@tiptap/extension-horizontal-rule'
import CodeBlock from '@tiptap/extension-code-block'
import Dropcursor from '@tiptap/extension-dropcursor'
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight'
import css from 'highlight.js/lib/languages/css'
import js from 'highlight.js/lib/languages/javascript'
import ts from 'highlight.js/lib/languages/typescript'
import html from 'highlight.js/lib/languages/xml'
import { all, createLowlight } from 'lowlight'

import Gapcursor from '@tiptap/extension-gapcursor'
import Table from '@tiptap/extension-table'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'
import TableRow from '@tiptap/extension-table-row'
import TaskItem from '@tiptap/extension-task-item'
import TaskList from '@tiptap/extension-task-list'

import Youtube from '@tiptap/extension-youtube'

import Bold from '@tiptap/extension-bold'
import Code from '@tiptap/extension-code'
import Highlight from '@tiptap/extension-highlight'
import Italic from '@tiptap/extension-italic'
import Link from '@tiptap/extension-link'
import Strike from '@tiptap/extension-strike'

import { EditorContent, useEditor } from '@tiptap/react'

import './styles.scss'


import FormatUnderlinedIcon from '@mui/icons-material/FormatUnderlined';
import ClearIcon from '@mui/icons-material/Clear';
import SuperscriptIcon from '@mui/icons-material/Superscript';
import SubscriptIcon from '@mui/icons-material/Subscript';
import StrikethroughSIcon from '@mui/icons-material/StrikethroughS';
import AddLinkIcon from '@mui/icons-material/AddLink';
import LinkOffOutlinedIcon from '@mui/icons-material/LinkOffOutlined';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import CodeIcon from '@mui/icons-material/Code';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import ImageIcon from '@mui/icons-material/Image';
import TitleIcon from '@mui/icons-material/Title';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import YouTubeIcon from '@mui/icons-material/YouTube';
import SegmentOutlinedIcon from '@mui/icons-material/SegmentOutlined';
import SortOutlinedIcon from '@mui/icons-material/SortOutlined';
import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import DataObjectIcon from '@mui/icons-material/DataObject';
import VerticalAlignCenterOutlinedIcon from '@mui/icons-material/VerticalAlignCenterOutlined';
import SubdirectoryArrowRightOutlinedIcon from '@mui/icons-material/SubdirectoryArrowRightOutlined';
import RemoveIcon from '@mui/icons-material/Remove';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import BorderAllOutlinedIcon from '@mui/icons-material/BorderAllOutlined';
import AddRoadOutlinedIcon from '@mui/icons-material/AddRoadOutlined';
import RemoveRoadOutlinedIcon from '@mui/icons-material/RemoveRoadOutlined';
import CancelPresentationOutlinedIcon from '@mui/icons-material/CancelPresentationOutlined';
import MoveDownOutlinedIcon from '@mui/icons-material/MoveDownOutlined';
import MoveUpOutlinedIcon from '@mui/icons-material/MoveUpOutlined';
import FormatIndentDecreaseOutlinedIcon from '@mui/icons-material/FormatIndentDecreaseOutlined';
import FormatIndentIncreaseOutlinedIcon from '@mui/icons-material/FormatIndentIncreaseOutlined';
import CallMergeOutlinedIcon from '@mui/icons-material/CallMergeOutlined';
import AltRouteOutlinedIcon from '@mui/icons-material/AltRouteOutlined';
import HealingOutlinedIcon from '@mui/icons-material/HealingOutlined';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
import PlaylistAddOutlinedIcon from '@mui/icons-material/PlaylistAddOutlined';
import Placeholder from '@tiptap/extension-placeholder'
import { AnimatePresence, motion } from 'framer-motion'
function RTE(
  {
    setEditorContent,
    setAddYoutubeVideoShow,
    videoAdded,
    editorContent,
    isEditable,
    setattachmentRef,
    isDataChanged,
    setIsDataChanged,
    setTags
  }
) {
  // create a lowlight instance with all languages loaded

  const lowlight = createLowlight(all)

  // This is only an example, all supported languages are already loaded above
  // but you can also register only specific languages to reduce bundle-size
  lowlight.register('html', html)
  lowlight.register('css', css)
  lowlight.register('js', js)
  lowlight.register('ts', ts)

  const [height, setHeight] = useState(480)
  const [width, setWidth] = useState(640)

  const editor = useEditor({
    extensions: [

      Placeholder.configure({
        placeholder: 'Type your message here...',
        showOnlyWhenEditable: true,
      }),
      Bold,
      Code,
      Highlight.configure({ multicolor: true }),
      Italic,
      Strike,
      Subscript,
      Superscript,
      TextStyle.configure({ mergeNestedSpanStyles: true }),
      Color,
      FontFamily,
      Link.configure({
        openOnClick: true,
        autolink: true,
        defaultProtocol: 'https',
        protocols: ['http', 'https'],
        isAllowedUri: (url, ctx) => {
          try {
            // construct URL
            const parsedUrl = url.includes(':') ? new URL(url) : new URL(`${ctx.defaultProtocol}://${url}`)

            // use default validation
            if (!ctx.defaultValidate(parsedUrl.href)) {
              return false
            }

            // disallowed protocols
            const disallowedProtocols = ['ftp', 'file', 'mailto']
            const protocol = parsedUrl.protocol.replace(':', '')

            if (disallowedProtocols.includes(protocol)) {
              return false
            }

            // only allow protocols specified in ctx.protocols
            const allowedProtocols = ctx.protocols.map(p => (typeof p === 'string' ? p : p.scheme))

            if (!allowedProtocols.includes(protocol)) {
              return false
            }

            // disallowed domains
            const disallowedDomains = ['example-phishing.com', 'malicious-site.net']
            const domain = parsedUrl.hostname

            if (disallowedDomains.includes(domain)) {
              return false
            }

            // all checks have passed
            return true
          } catch {
            return false
          }
        },
        shouldAutoLink: url => {
          try {
            // construct URL
            const parsedUrl = url.includes(':') ? new URL(url) : new URL(`https://${url}`)

            // only auto-link if the domain is not in the disallowed list
            const disallowedDomains = ['example-no-autolink.com', 'another-no-autolink.com']
            const domain = parsedUrl.hostname

            return !disallowedDomains.includes(domain)
          } catch {
            return false
          }
        },

      }),
      Underline,
      Document,
      Paragraph,
      Text,
      HardBreak,
      Blockquote,
      BulletList,
      Image,
      OrderedList,
      Mention.configure({
        HTMLAttributes: {
          class: 'mention',
        },
        suggestion,
      }),
      ListItem,
      CodeBlock,
      Heading.configure({
        levels: [1, 2, 3],
      }),
      HorizontalRule,
      Document,
      Dropcursor,
      CodeBlockLowlight.configure({
        lowlight,
      }),
      Gapcursor,
      Table.configure({
        resizable: true,
        HTMLAttributes: {
          class: 'table table-bordered table-hover table-striped',
        },
      }),
      TableRow,
      TableHeader,
      TableCell,
      TaskList,
      TaskItem.configure({
        nested: true,
      }),
      Youtube.configure({
        controls: false,
        nocookie: true,
      }),

    ],
    content: editorContent,
    editable: isEditable,
    editorProps: {
      attributes: {
        spellcheck: 'false',
      },
      rows: 10
    },
    onUpdate({ editor }) {
      // console.log(editor.getHTML())
      if (editor.getHTML() === "<p></p>") {
        // console.log("Comment is default")
        setIsDataChanged({ "comments": false, "assignedment": isDataChanged.assignedment, "status": isDataChanged.status })
      } else {
        // console.log("Comment is changed")
        setIsDataChanged({ "comments": true, "assignedment": isDataChanged.assignedment, "status": isDataChanged.status })
      }

      setEditorContent(editor.getHTML());
    },
    onTransaction: ({ editor, transaction }) => {
      // Extract mention nodes from editor JSON
      const mentions = extractMentions(editor);
    
      if (mentions.length > 0) {
        // console.log("Mentions detected:", mentions);
        setTags(mentions)
      }
    },
  })

  // Function to extract mentions from editor content
  const extractMentions = (editor) => {
    const jsonContent = editor.getJSON();
    const mentions = [];

    // Recursively search for mention nodes
    const findMentions = (node) => {
      if (!node) return;

      if (node.type === "mention") {
        mentions.push({"id":node.attrs.id,"label":node.attrs.label}); // Extract mention name
      }

      if (node.content) {
        node.content.forEach(findMentions);
      }
    };

    jsonContent.content.forEach(findMentions);
    return mentions;
  };


  const addImage = useCallback(() => {
    const url = window.prompt('URL')

    if (url) {
      editor.chain().focus().setImage({ src: url }).run()
    }
  }, [editor])

  const setLink = useCallback(() => {
    const previousUrl = editor.getAttributes('link').href
    const url = window.prompt('URL', previousUrl)

    // cancelled
    if (url === null) {
      return
    }

    // empty
    if (url === '') {
      editor.chain().focus().extendMarkRange('link').unsetLink()
        .run()

      return
    }

    // update link
    try {
      editor.chain().focus().extendMarkRange('link').setLink({ href: url })
        .run()
    } catch (e) {
      alert(e.message)
    }
  }, [editor])


  const [showAdvanceManue, setShowAdvanceMenue] = useState(false)



  useEffect(() => {
    console.log(videoAdded)
    if (videoAdded.length > 0) {
      editor.commands.setYoutubeVideo({
        src: videoAdded,
        width: Math.max(320, parseInt(width, 10)) || 640,
        height: Math.max(180, parseInt(height, 10)) || 480,
      })
    }
  }, [videoAdded])

  if (!editor) {
    return null
  }

  return (
    <>
      <div className="w-100 d-flex flex-column" >

        <AnimatePresence>
          {
            showAdvanceManue &&
            <motion.div
              initial={{ transformOrigin: "left", scaleX: 0, opacity: 0 }}
              animate={{ transformOrigin: "left", scaleX: 1, opacity: 1 }}
              exit={{ transformOrigin: "left", scaleX: 0, opacity: 0 }}
              transition={{ delay: 0, duration: .3 }}
              className={`RTE-controls w-100 bg-light p-2 ${isEditable ? "" : "d-none"}`}>
              <button type='button'>
                <label htmlFor='uthaLeImage1' className='m-0'>
                  <img src={AttachmentIcon} alt="" style={{ height: "25px" }} />
                </label>
                <input type="file" multiple id="uthaLeImage1" className='form-control w-100 d-none' onInput={(e) => { setattachmentRef(e.target.files) }} />
              </button>
              <input
                type="color"
                onInput={event => editor.chain().focus().setColor(event.target.value).run()}
                value={editor.getAttributes('textStyle').color}
                data-testid="setColor"
              />
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleUnderline().run()}
                className={editor.isActive('underline') ? 'is-active' : ''}
              >
                <FormatUnderlinedIcon />
              </button>

              <button
                type='button'
                onClick={() => editor.chain().focus().toggleSubscript().run()}
                className={editor.isActive('subscript') ? 'is-active' : ''}
              >
                <SubscriptIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleSuperscript().run()}
                className={editor.isActive('superscript') ? 'is-active' : ''}
              >
                <SuperscriptIcon />
              </button>

              <button
                type='button'
                onClick={() => editor.chain().focus().toggleStrike().run()}
                className={editor.isActive('strike') ? 'is-active' : ''}
              >
                <StrikethroughSIcon />
              </button>
              <button
                type='button' onClick={setLink} className={editor.isActive('link') ? 'is-active' : ''}>
                <AddLinkIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().unsetLink().run()}
                disabled={!editor.isActive('link')}
              >
                <LinkOffOutlinedIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleItalic().run()}
                className={editor.isActive('italic') ? 'is-active' : ''}
              >
                <FormatItalicIcon />
              </button>


              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight().run()}
                className={editor.isActive('highlight') ? 'is-active' : ''}
                title='Highlint'
              >
                <DriveFileRenameOutlineIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight({ color: '#ffc078' }).run()}
                className={editor.isActive('highlight', { color: '#ffc078' }) ? 'is-active' : ''}
                title='Orange Highlight'
                style={{ background: "Orange" }}
              >

              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight({ color: '#8ce99a' }).run()}
                className={editor.isActive('highlight', { color: '#8ce99a' }) ? 'is-active' : ''}
                title='Green Highlight'
                style={{ background: "Green" }}
              >


              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight({ color: '#74c0fc' }).run()}
                className={editor.isActive('highlight', { color: '#74c0fc' }) ? 'is-active' : ''}
                title='Blue Highlight'
                style={{ background: "Blue" }}
              >

              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight({ color: '#b197fc' }).run()}
                className={editor.isActive('highlight', { color: '#b197fc' }) ? 'is-active' : ''}
                title='Purple Highlight'
                style={{ background: "Purple" }}
              >


              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight({ color: 'red' }).run()}
                className={editor.isActive('highlight', { color: 'red' }) ? 'is-active' : ''}
                title='Red Highlight'
                style={{ background: "Red" }}
              >

              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHighlight({ color: '#ffa8a8' }).run()}
                className={editor.isActive('highlight', { color: '#ffa8a8' }) ? 'is-active' : ''}
                title='red Highlight'
                style={{ background: "#ffa8a8" }}
              >

              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleCode().run()}
                className={editor.isActive('code') ? 'is-active' : ''}
                title='Toggle Code'
              >
                <CodeIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleBold().run()}
                className={editor.isActive('bold') ? 'is-active' : ''}
              >
                <FormatBoldIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().setHorizontalRule().run()}
                title='Set horizontal rule'>
                <HorizontalRuleIcon />
              </button>
              <button
                type='button' onClick={addImage} title=''>Set image</button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
                className={editor.isActive('heading', { level: 1 }) ? 'is-active' : ''}
                title='H1'
              >
                H1
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
                className={editor.isActive('heading', { level: 2 }) ? 'is-active' : ''}
                title='H2'
              >
                H2
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleHeading({ level: 3 }).run()}
                className={editor.isActive('heading', { level: 3 }) ? 'is-active' : ''}
                title='H3'
              >
                H3
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleBlockquote().run()}
                className={editor.isActive('blockquote') ? 'is-active' : ''}
                title='Toggle blockquote'
              >
                <FormatQuoteIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleBulletList().run()}
                className={editor.isActive('bulletList') ? 'is-active' : ''}
                title='Toggle bullet list'
              >
                <FormatListBulletedIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleOrderedList().run()}
                className={editor.isActive('orderedList') ? 'is-active' : ''}
                title=' Toggle ordered list'
              >
                <FormatListNumberedIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().splitListItem('listItem').run()}
                disabled={!editor.can().splitListItem('listItem')}
                title='Split list item'
              >
                <BallotOutlinedIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().sinkListItem('listItem').run()}
                disabled={!editor.can().sinkListItem('listItem')}
                title='Sink list item'
              >
                <SegmentOutlinedIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().liftListItem('listItem').run()}
                disabled={!editor.can().liftListItem('listItem')}
                title='Lift list item'
              >
                <SortOutlinedIcon />
              </button>
              <button
                type='button'
                onClick={() => editor.chain().focus().toggleCodeBlock().run()}
                className={editor.isActive('codeBlock') ? 'is-active' : ''}
                title='Toggle code block'
              >
                <DataObjectIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().setHardBreak().run()} title='Set hard break'>
                <SubdirectoryArrowRightOutlinedIcon />
              </button>

              <button
                type='button'
                onClick={() => editor.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: true }).run()
                }
                title='Insert Table'
              >
                <BorderAllOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().deleteTable().run()} title='Delete table'>
                <CancelPresentationOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().addColumnBefore().run()} title='Add column before'>
                <FormatIndentDecreaseOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().addColumnAfter().run()} title='Add column after'>
                <FormatIndentIncreaseOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().deleteColumn().run()} title='Delete column'>
                <ClearIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().addRowBefore().run()} title='Add row before'>
                <MoveUpOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().addRowAfter().run()} title='Add row after'>
                <MoveDownOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().deleteRow().run()} title='Delete row'>
                <RemoveIcon />
              </button>

              <button
                type='button' onClick={() => editor.chain().focus().mergeCells().run()} title='Merge cells'>
                <CallMergeOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().splitCell().run()} title='Split cell'>
                <AltRouteOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().toggleHeaderColumn().run()} title='Toggle header column'>
                <TitleIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().toggleHeaderRow().run()} title="Toggle Header Line">
                <TitleIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().toggleHeaderCell().run()} title='Toggle header cell'>
                <TitleIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().mergeOrSplit().run()} title='Merge Cells'>
                <CallMergeOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().setCellAttribute('colspan', 2).run()}>Set cell attribute</button>
              <button
                type='button' onClick={() => editor.chain().focus().fixTables().run()} title='Fix table'>
                <HealingOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().goToPreviousCell().run()} title='previous cell'>
                <ArrowBackOutlinedIcon />
              </button>
              <button
                type='button' onClick={() => editor.chain().focus().goToNextCell().run()} title='next cell'>
                <ArrowForwardOutlinedIcon />
              </button>

              <button
                type='button'
                onClick={() => editor.chain().focus().toggleTaskList().run()}
                className={editor.isActive('taskList') ? 'is-active' : ''}
                title='Toggle task list'
              >
                <PlaylistAddOutlinedIcon />
              </button>
              <button type='button' className='youtubeAddButton' id="add" onClick={() => { setAddYoutubeVideoShow(true) }}><YouTubeIcon /></button>
            </motion.div>
          }
        </AnimatePresence>

        <div className='h-100 w-100 d-flex align-items-end gap-3 overflow-auto' style={isEditable ? { maxHeight: "400px" } : {}}>
          {
            isEditable &&
            <button type='button' onClick={() => { setShowAdvanceMenue(!showAdvanceManue) }} className='btn btn-sm btn-light rounded-circle p-0 sticky-bottom' style={{ aspectRatio: "1/1", height: "40px" }}>
              <WidgetsIcon />
            </button>
          }

          <EditorContent editor={editor} className={`h-100 w-100 ${isEditable ? "activatedEditor" : "noneActiveEditor"}`} required={isEditable ? true : false} />
        </div>

      </div>
    </>
  )
}

export default RTE